import {
  CheckCircleOutlineOutlined,
  ErrorOutlineOutlined,
  InfoOutlined,
  WarningAmberOutlined,
} from "@mui/icons-material";

import {
  DialogContentText,
  DialogActions,
  Paper,
  Modal,
  Typography,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Stack,
  useTheme,
  alpha,
} from "@mui/material";

export default function NewAlertModal(props) {
  const {
    openModal,
    setOpenModal,
    confirmar = false,
    handleButton = () => {},
    handleCancel = () => {},
    severity = "success",
    textContent,
    singleButton = true,
    customButton,
    buttonText,
    buttonCancelText,
  } = props;

  const theme = useTheme();
  const alertText = () => {
    if (textContent) {
      return textContent;
    }
    return severity === "success"
      ? "Sucesso na operação!"
      : severity === "warning"
        ? "Se você prosseguir com a operação o item será editado permanentemente e os dados anteriores são perdidos!"
        : severity === "info"
          ? "Está ação pode ser permanentemente!"
          : "Se você prosseguir com a operação o item será deletado e os dados apagados serão perdidos permanentemente!";
  };
  const alertTitle = () => {
    return severity === "success"
      ? "Sucesso!"
      : severity === "warning"
        ? "Alerta!"
        : severity === "info"
          ? "Informação"
          : "Atenção!";
  };
  const buttonTextDefault = () => {
    if (buttonText) {
      return buttonText;
    }
    return severity === "success"
      ? "Aceitar"
      : severity === "warning"
        ? "Prosseguir"
        : severity === "info"
          ? "Confirmar"
          : "Excluir";
  };

  const paletteKey = () => {
    return severity === "success"
      ? "sucess"
      : severity === "warning"
        ? "warning"
        : severity === "info"
          ? "info"
          : "error";
  };
  const color = () => `${paletteKey()}.main`;
  const mainColor = theme.palette[paletteKey()].main;
  const stylesModal = {
    boxRowFields: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      with: "100%",
      gap: 1,
    },
    Paper: {
      padding: 3,
      maxWidth: "332px",
      width: "100%",
      minWidth: "232px",
      maxHeight: "90vh",
      gap: 2,
      flexDirection: "column",
      display: "flex",
      alignItems: "center",
    },
    dialogTitle: {
      padding: 0,
    },
    DialogContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      padding: 0,
    },
    DialogContentText: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      textAlign: "center",
      color: "text.secondary",
    },
    DialogActions: {
      display: "flex",
      flexDirection: "row",
      justifyContent: singleButton ? "center" : "space-between",
      width: "100%",
    },
    ButtonConfirm: {
      fontWeight: 500,
      color: "#ffffff",
      backgroundColor: `${color()}`,
      width: singleButton ? "90%" : "35%",
      borderRadius: "3px",
    },
    ButtonCancel: {
      backgroundColor: "background.textField",
      color: "text.primary",
      borderRadius: "3px",
    },
    Icon: {
      width: 66,
      height: 66,
      color:
        severity === "error"
          ? "error.main"
          : severity === "success"
            ? "sucess.main"
            : severity === "warning"
              ? "warning.main"
              : "info.main",
    },
    modal: { display: "flex", justifyContent: "center", alignItems: "center" },
  };

  return (
    <Modal
      open={openModal}
      closeAfterTransition
      onClose={() => {
        setOpenModal(false);
      }}
      sx={stylesModal.modal}
    >
      <Paper sx={stylesModal.Paper}>
        <DialogTitle sx={stylesModal.dialogTitle}>
          <Box sx={stylesModal.boxRowFields}>
            <Stack
              sx={{
                color: mainColor,
                backgroundColor: alpha(mainColor, 0.2),
                borderRadius: "100%",
                height: 86,
                width: 86,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {severity === "success" ? (
                <CheckCircleOutlineOutlined sx={stylesModal.Icon} />
              ) : severity === "error" ? (
                <ErrorOutlineOutlined sx={stylesModal.Icon} />
              ) : severity === "info" ? (
                <InfoOutlined sx={stylesModal.Icon} />
              ) : (
                <WarningAmberOutlined sx={stylesModal.Icon} />
              )}
            </Stack>
            <Typography variant="h5">{alertTitle()}</Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={stylesModal.DialogContent}>
          <DialogContentText sx={stylesModal.DialogContentText}>
            <Typography fontSize={16}>{alertText()}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={stylesModal.DialogActions}>
          {singleButton === true ? (
            <Button
              autoFocus
              variant="contained"
              color={severity}
              sx={stylesModal.ButtonConfirm}
              onClick={handleButton}
              disabled={confirmar}
            >
              {buttonTextDefault()}
            </Button>
          ) : (
            <>
              <Button
                variant="contained"
                color="inherit"
                onClick={() => {
                  setOpenModal(false);
                  handleCancel();
                }}
                sx={stylesModal.ButtonCancel}
              >
                {buttonCancelText ?? "Cancelar"}
              </Button>

              <Button
                autoFocus
                variant="contained"
                color={severity}
                sx={stylesModal.ButtonConfirm}
                onClick={handleButton}
                disabled={confirmar}
              >
                {buttonTextDefault()}
              </Button>
            </>
          )}
          {customButton}
        </DialogActions>
      </Paper>
    </Modal>
  );
}
